/* eslint-disable no-useless-escape */
import Vue from "vue";

let showErrorCode = function() {
  // let val = zh.errorCode[errCode];
  // if (val) {
  //   return i18n.t("errorCode." + errCode);
  // } else {
  //   // .name == "Login"  VcodeLogin
  //   let rname = store.state.route.name;
  //   let i18nKey = "errorCode.serverException";
  //   if (rname == "Login" || rname == "VcodeLogin") {
  //     i18nKey = "errorCode.loginException";
  //   }
  //   return i18n.t(i18nKey, { code: errCode });
  // }
};

/**图片放大预览end */

/**文件下载 start*/
let downloadFile = function(sUrl) {
  //iOS devices do not support downloading. We have to inform user about this.
  if (/(iP)/g.test(navigator.userAgent)) {
    alert(
      "Your device does not support files downloading. Please try again in desktop browser."
    );
    return false;
  }

  //If in Chrome or Safari - download via virtual link click
  if (
    downloadFile.isChrome ||
    downloadFile.isSafari ||
    downloadFile.isFirefox
  ) {
    //Creating new link node.
    var link = document.createElement("a");
    // var fileName = sUrl.substring(sUrl.lastIndexOf("/") + 1, sUrl.length);
    // var filePath = sUrl.substring(0, sUrl.lastIndexOf("/") + 1);
    link.href = encodeURI(sUrl);
    // link.href = encodeURIComponent(sUrl);
    // link.href = sUrl;
    // link.href = encodeURI(filePath) + encodeURIComponent(fileName);
    link.target = "_blank";

    if (link.download !== undefined) {
      //Set HTML5 download attribute. This will prevent file from opening if supported.
      var fileName = sUrl.substring(sUrl.lastIndexOf("/") + 1, sUrl.length);
      link.download = fileName;
    }

    //Dispatching click event.
    if (document.createEvent) {
      var e = document.createEvent("MouseEvents");
      e.initEvent("click", true, true);
      link.dispatchEvent(e);
      return true;
    }
  }

  // Force file download (whether supported by server).
  if (sUrl.indexOf("?") === -1) {
    sUrl += "?download";
  }

  window.open(sUrl, "_blank");
  return true;
};
downloadFile.isChrome =
  navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
downloadFile.isSafari =
  navigator.userAgent.toLowerCase().indexOf("safari") > -1;
downloadFile.isFirefox =
  navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**文件下载 end*/

/**常用正则表达式 */
let constReg = {
  //电子邮箱
  email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  //手机号码 11位
  phone: /^((1[358][0-9])|(14[57])|(17[0678])|(19[7]))\d{8}$/,
  //中文、英文、数字、空白字符
  cnenName: /^[\u4e00-\u9fa5a-zA-Z0-9\s+]+$/,
  //中文、英文、数字、_-
  cnenName1: /^[\u4e00-\u9fa5a-zA-Z0-9_-]+$/,
  cnenName2: /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9_-]{1,19}$/,
  cnenName3: /^[\u4e00-\u9fa5a-zA-Z&]+$/,
  cnenName4: /^[\u4e00-\u9fa5a-zA-Z0-9.//\(\)（）_-]+$/,
  //支持英文、数字、下划线、中划线，首位必须是字母，长度最少2位最多20位
  name: /[~,',‘,’,”,",“,#,\\,\,%,|,]+/,
  nameMsg: "不支持如下特殊字符~、#、‘、%、|、\\",
  //大写英文字母
  uppercaseEn: /^[A-Z]+$/,
  //英文字母、数字、特殊字符(!-+*@#$.)，中的至少2种组合。8位到20位
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![!_\-+*@#$.]+$)[0-9A-Za-z!_\-+*@#$.]{8,20}$/,
  //大小写英文字母、数字、8位到20位
  // password2: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,32}$/,
  password2: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{8,32}$/,

  name1: /^[a-zA-Z0-9\u4E00-\u9FA5_\(\)（）\.。，,$-—]{1,150}$/, //名称为数字、英文、中文、下划线 150个字符以内
  name2: /^[\u4E00-\u9FA5A-Za-z0-9_]{1,30}$/, //数字，英文，中文、下划线 30个字符以内
  num: /^([1-9][0-9]*)(\.[0-9]{1,2})?$/, //正整数、最多保留2位小数。
  num4: /^([1-9][0-9]*)(\.[0-9]{1,4})?$/, //正整数、最多保留2位小数。
  // num: /^(0|([1-9][0-9]*))(\.[0-9]{1,2})?$/, //正整数、最多保留2位小数。
  num2: /^(0|-?([1-9][0-9]*))(\.[0-9]{1,2})?$/, //负整数,正整数、最多保留2位小数。
  num3: /^(0(\.\d{1,4})?|1(\.0{1,4})?)$/, //0到1之间的小数，最多4位小数，包括0和1

  positiveInt: /^[1-9]\d*$/, //匹配正整数
  nonnegativeInt: /^([1-9][0-9]*|0)$/, //非负整数
  chinese: /^[\u4e00-\u9fa5]+$/,
  encryptTel: {
    reg: /(\(\d*\))?(\d{3})\d{1,4}(\d*)/, // 加密电话
    replace: "$1$2****$3"
  },
  english: /^[A-Za-z]+$/,
  //  /^\+?[1-9][0-9]*$/

  //URL规则：
  //(1)、地址必须以http/https/ftp/ftps开头；
  //(2) 、地址不能包含双字节符号或非链接特殊字符
  url: /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/ //
};

//后代组件  对父组件发送事件
//componentName:父组件名称, eventName:事件名称, params:传递的数据
let dispatch = function(componentName, eventName, params) {
  var parent = this.$parent || this.$root;
  var name = parent.$options.componentName;

  //寻找父级，如果父级不是符合的组件名，则循环向上查找
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;

    if (parent) {
      name = parent.$options.componentName;
    }
  }
  //找到符合组件名称的父级后，触发其事件。整体流程类似jQuery的closest方法
  if (parent) {
    parent.$emit.apply(parent, [eventName].concat(params));
  }
};

//事件广播  父组件向 后代组件
//componentName:子组件名称, eventName:事件名称, params:传递的数据
let broadcast = function(componentName, eventName, params) {
  broadcast.call(this, componentName, eventName, params);
  function broadcast(componentName, eventName, params) {
    //遍历所有子组件
    this.$children.forEach(child => {
      var name = child.$options.componentName;
      //寻找符合指定名称的子组件
      if (name === componentName) {
        //在符合的自组件上触发的事件，但是不会再继续寻找符合名称的组件的子集，原因？
        child.$emit.apply(child, [eventName].concat(params));
      } else {
        //不符合继续寻找他的子集（即孙子组件）
        broadcast.apply(child, [componentName, eventName].concat([params]));
      }
    });
  }
};
let encodeB64 = function(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
};
let decodeB64 = function(str) {
  return decodeURIComponent(escape(window.atob(str)));
};

let jsonParse = function(jsonStr) {
  try {
    var jsonObj = JSON.parse(jsonStr);
    if (Object.prototype.toString.call(jsonObj) === "[object Object]") {
      return jsonObj;
    } else {
      throw new Error("jsonParse:: the result of parse is not object");
    }
  } catch (err) {
    let message = "jsonParse:: jsonStr is not standard string";
    if (err.constructor == Error) {
      message = err.message;
    }
    console.error(message);
    console.error(err);
    return {};
  }
};
let jsonStringify = function(jsonObj) {
  try {
    var jsonStr = JSON.stringify(jsonObj);
    return jsonStr;
  } catch (err) {
    Vue.prototype.$message({
      message: "jsonStringify::jsonObj is not standard object"
    });
    console.error(err);
    return "";
  }
};

let getOSType = function() {
  var platform = navigator.platform;
  var osType = "";
  switch (platform) {
    case "Win32":
    case "Windows":
      osType = "windows";
      break;
    case "Mac68K":
    case "MacPPC":
    case "Macintosh":
    case "MacIntel":
      osType = "macos";
      break;
    default:
      osType = "windows";
  }
  return osType;
};

let getBrowserType = function() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
  // var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
  // var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
  // 判断是否为小于IE11的浏览器
  var isLessIE11 =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
  // 判断是否为IE的Edge浏览器
  var isEdge = userAgent.indexOf("Edge") > -1 && !isLessIE11;
  // 判断是否为IE11浏览器
  var isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
  var isSafari =
    userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
  var isChrome =
    userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

  if (isLessIE11) {
    var IEReg = new RegExp("MSIE (\\d+\\.\\d+);");
    // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
    IEReg.test(userAgent);
    // 取正则表达式中第一个小括号里匹配到的值
    var IEVersionNum = parseFloat(RegExp["$1"]);
    if (IEVersionNum === 7) {
      // IE7
      return "IE7";
    } else if (IEVersionNum === 8) {
      // IE8
      return "IE8";
    } else if (IEVersionNum === 9) {
      // IE9
      return "IE9";
    } else if (IEVersionNum === 10) {
      // IE10
      return "IE10";
    } else {
      // IE版本<7
      return "IE6";
    }
  } else if (isEdge) {
    // edge
    return "Edge";
  } else if (isIE11) {
    // IE11
    return "IE11";
  }
  /* if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE7";
    } else if (fIEVersion == 8) {
      return "IE8";
    } else if (fIEVersion == 9) {
      return "IE9";
    } else if (fIEVersion == 10) {
      return "IE10";
    } else if (fIEVersion == 11) {
      return "IE11";
    } else {
      return "0";
    } //IE版本过低
    return "IE";
  } */
  if (isOpera) {
    return "Opera";
  }
  if (isEdge) {
    return "Edge";
  }
  if (isFF) {
    return "Firefox";
  }
  if (isSafari) {
    return "Safari";
  }
  if (isChrome) {
    return "Chrome";
  }
};

//判断数据类型
/* 返回值：这里只列举了一部分(dom级别的也是可以判断的)
  "String" |"Number"|"Boolean"|"Function"|"Array"|"Object"|"Undefined"|"Null"
*/
let typeOf = function(val) {
  let str = Object.prototype.toString.call(val);
  let index = str.indexOf(" ");
  let rs = str.slice(index + 1, str.length - 1);
  if (rs == "Number" && Number.isNaN(val)) {
    rs = "NaN";
  }
  return rs;
};

//作为插件必须定义公开的 install 方法
// export default function install(Vue, options) {
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
Vue.prototype.$encodeB64 = encodeB64;
Vue.prototype.$decodeB64 = decodeB64;
Vue.prototype.$dispatch = dispatch;
Vue.prototype.$broadcast = broadcast;
Vue.prototype.$downloadFile = downloadFile;
Vue.prototype.$constReg = constReg;
Vue.prototype.$jsonStringify = jsonStringify;
Vue.prototype.$jsonParse = jsonParse;
Vue.prototype.$showErrorCode = showErrorCode;
Vue.prototype.$getOSType = getOSType;
Vue.prototype.$getBrowserType = getBrowserType;
Vue.prototype.$typeOf = typeOf;

// }
